// @flow
import * as React from 'react';
import BoardPickerRowIcon from 'app/common/react/components/save/pin-to-board/BoardPickerPane/BoardPickerRowIcon';
import CONST from 'app/common/lib/Const';
import i18n from 'app/common/lib/i18n';
import PickerFlyout from 'app/common/react/components/RepinPicker/PickerFlyout/PickerFlyout';
import type { MergeFlowBoard } from 'app/common/react/components/BoardEdit/BoardMergeModalContent';
import { getBoardLabel } from 'app/common/react/components/save/pin-to-board/BoardPickerPane/BoardPickerRow';
import { Box, Text } from 'gestalt';

type Props = {|
  boards: Array<MergeFlowBoard>,
  fetchMore?: () => void,
  onSearchQueryUpdate: (searchQuery: string) => void,
  onSelect: (board: ?MergeFlowBoard) => void,
  searchQuery: string,
  selectedBoard: ?MergeFlowBoard,
|};

export default function BoardMergeTargetPickerFlyout({
  boards,
  fetchMore,
  selectedBoard,
  onSelect,
  onSearchQueryUpdate,
  searchQuery,
}: Props) {
  return (
    // $FlowFixMe: new errors found from flow 0.96 upgrade
    <PickerFlyout
      dropdownValue={selectedBoard ? selectedBoard.name : i18n._('Pick a board')}
      fetchMore={fetchMore}
      onSearchQueryUpdate={onSearchQueryUpdate}
      onSelect={onSelect}
      renderRow={({ item: { name, privacy, is_collaborative: isCollaborative }, hovered }) => (
        <Box color={hovered ? 'lightGray' : 'white'} display="flex" padding={2} shape="rounded">
          <Box flex="grow">
            <Text bold>{getBoardLabel(searchQuery, name)}</Text>
          </Box>
          <Box display="flex" flex="none" direction="row">
            {privacy === CONST.BoardPrivacy.SECRET && <BoardPickerRowIcon type="secret" />}
            {isCollaborative && <BoardPickerRowIcon type="group" />}
          </Box>
        </Box>
      )}
      searchQuery={searchQuery}
      sections={[{ items: boards }]}
    />
  );
}
